import { render, staticRenderFns } from "./sheet.vue?vue&type=template&id=3c0c1af5&scoped=true"
import script from "./sheet.vue?vue&type=script&lang=js"
export * from "./sheet.vue?vue&type=script&lang=js"
import style0 from "./sheet.vue?vue&type=style&index=0&id=3c0c1af5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c1af5",
  null
  
)

export default component.exports